import gql from "graphql-tag";
import PropTypes from "prop-types";

export default {
  mutation: gql`
    mutation addCardLimit(
      $cardId: ID!
      $groupId: String!
      $limitType: LimitTypeInput!
      $limitPeriod: LimitPeriodInput!
      $limitValue: Float!
    ) {
      addNewCardLimit(
        cardId: $cardId
        groupId: $groupId
        limitType: $limitType
        limitPeriod: $limitPeriod
        limitValue: $limitValue
      ) {
        success
      }
    }
  `,
  config: {
    skip: (ownProps) => !ownProps.cardId,
    options: ({
      cardId,
      groupId,
      // limitType,
      limitPeriod,
      limitValue,
    }) => ({
      variables: {
        cardId,
        groupId,
        limitType: 0,
        limitPeriod,
        limitValue,
      },
    }),
  },
  propTypes: {
    cardId: PropTypes.string.isRequired,
    groupId: PropTypes.string.isRequired,
    // limitType: PropTypes.string.isRequired,
    limitPeriod: PropTypes.oneOf(["DAILY", "MONTHLY", "CUSTOM"]).isRequired,
    limitValue: PropTypes.number.isRequired,
  },
};



// WEBPACK FOOTER //
// ./src/model/gql/mutations/cards/cardLimit/addCardLimit.js